import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnFileUploaderComponent, FileUploaderArquivo } from "@bndes/bndes-ux4/bn-file-uploader";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { LimiteExposicao, LimiteLegadoDTO } from "src/app/model/limite-exposicao.model";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { FileUtilsService } from "src/app/shared/file-utils.service";

export interface LimiteResponseDto {
    atualizadoEm: string;
    valorPatrimonioLiquido: string;
    valorLimiteExposicao: string;
    valorExposicaoAtual: string;
    valorDisponivel: string;
    valorLimiteLegado: string;

    valorExposicaoAtualGrandesEmpresas: string;
    valorLimiteExposicaoGrandesEmpresas: string;
    valorDisponivelGrandesEmpresas: string;
    valorLimiteLegadoExposicaoGrandesEmpresas: string;
    dataBase: Date;
}

@Injectable({
    providedIn: 'root'
})
export class LimiteExposicaoService extends FgiBackEndService<LimiteExposicao> {

    private fileUtils: FileUtilsService;

    getNewEntity() {
        return new LimiteExposicao();
    }

    protected getResourceURL(): string {
        return 'front/limiteExposicao';
    }

    getUltimoLimiteLegadoImportado(): Observable<LimiteLegadoDTO> {
        return this.http.get(`${this.BASE_URL}/ultima-importacao-legado`).pipe(
            catchError((e) => this.handleError(e))) as Observable<LimiteLegadoDTO>;
    }

    getLimitePatrimonioLiquidoGlobal(): Observable<LimiteResponseDto> {
        return this.http.get(`${this.BASE_URL}/limite-global`).pipe(
            catchError((e) => this.handleError(e))) as Observable<LimiteResponseDto>;
    }

    getLimitesAgentesFinanceiros(id?: number): Observable<LimiteExposicao[]> {
        let params = new HttpParams();
        if (id) {
            params = params.append('idAgente', id);
        }
        return this.http.get(`${this.BASE_URL}/limites`, { params: params }).pipe(
            catchError((e) => this.handleError(e))) as Observable<LimiteExposicao[]>;
    }

    enviarArquivo(url: string, file: FileUploaderArquivo): Observable<any> {
        const formData = new FormData();
        formData.append('file', file.arquivo);
        return this.http.post(url, formData).pipe
            (catchError((e) => this.handleError(e))) as Observable<any>;
    }

    async importarArquivoLegado(uploader: BnFileUploaderComponent): Promise<any> {
        const url = `${this.BASE_URL}/importar-legado`;
        const listaPendente = [...uploader.listaPendente];
        for (const file of listaPendente) {
            await this.enviarArquivo(url, file).toPromise();
        }
    }

    async importarArquivoLegadoExposicaoSetor(uploader: BnFileUploaderComponent): Promise<any> {
        const url = `${this.BASE_URL}/importar-legado/exposicao-setor`;
        const listaPendente = [...uploader.listaPendente];
        for (const file of listaPendente) {
            await this.enviarArquivo(url, file).toPromise();
        }
    }

    importarValorLegadoExposicaoSetor(valorLegadoExposicaoSetor: any): Observable<any> {

      return this.http.post(`${this.BASE_URL}/importar-legado/exposicao-setor/${valorLegadoExposicaoSetor}`, {}).pipe(
            catchError((e) => this.handleError(e))) as Observable<any>;
    }

   

}
